/**============================================================
*   [inquiryValidateControl]
*   description : お問い合わせフォームのエラー文言処理
============================================================*/
const inquiryForm = document.getElementById('inquiryForm');

if (inquiryForm) {
  jQuery(document).on('wpcf7invalid', function () {
    jQuery.ajax().always(function () {

      // 既存のエラー文言を削除
      if (jQuery('.c-text-error').length) {
        jQuery('.c-text-error').each(function (index, prev_error) {
          jQuery(prev_error).remove();
        });
      }

      jQuery('.wpcf7-form-control-wrap').each(function (index, el) {
        if (jQuery(el).find('.wpcf7-not-valid-tip').length) {

          // エラー文言用classを追加
          jQuery(el).find('.wpcf7-not-valid-tip').addClass('c-text-error');

          // エラー文言表示位置を変更
          if (jQuery(el).closest('.p-form-container').length) {
            jQuery(el).closest('.p-form-container > div').before(jQuery(el).find('.wpcf7-not-valid-tip'));
          } else {
            jQuery(el).closest('.required > div').before(jQuery(el).find('.wpcf7-not-valid-tip'));
          }

          // 前の要素のエラー文言と重複していた場合
          jQuery('.wpcf7-not-valid-tip').each(function (index_ch, el_ch) {
            if (jQuery(el_ch).prev().text() == jQuery(el_ch).text()) {
              jQuery(el_ch).remove();
            }
          });

        }
      });

      // エラー文言表示時のスクロール処理
      const position = jQuery('.wpcf7-not-valid-tip:first').closest('tr').offset().top;
      const header = jQuery('#js-header').outerHeight();
      jQuery('html, body').animate({
        scrollTop: position - header
      }, 700);
    });
  });
}
